import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  FETCHING_PLANS,
  FETCHED_PLANS,
  GET_PLANS
} from "./constants";
const Gateway = apiGateway.find((gateway) => gateway.name === "client");

export const getPlans = (override = false, account_id) => async (dispatch) => {
  if ((!store.getState().plans.fetching && !store.getState().plans.fetched) || override) {
    dispatch({ type: FETCHING_PLANS, payload: true });
    return API.get(
      Gateway.name,
      `/plans/get-all/${(account_id || store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          "Authorization": store.getState().session.token
        }
      })
      .then(async (data) => {
        dispatch({ type: GET_PLANS, payload: data.payload });
        dispatch({ type: FETCHED_PLANS, payload: true });
        dispatch({ type: FETCHING_PLANS, payload: false });
        return data.payload;
      })
      .catch((error) => {
        if (error?.response?.data?.payload && !error.response.data.payload.length) dispatch({ type: GET_PLANS, payload: [] });
        dispatch({ type: FETCHED_PLANS, payload: true });
        dispatch({ type: FETCHING_PLANS, payload: false });
        return {
          success: false,
          error
        };
      });
  }
};